import { Button, Modal } from "react-bootstrap";

const DeleteModal = ({ handleDeleteResponse, show, title }) => {
    return (
        <>
            <Modal show={show} onHide={handleDeleteResponse}>
                <Modal.Header closeButton>
                    <Modal.Title>Delete {title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" className="btn btn-primary btn-add" onClick={() => { handleDeleteResponse(false) }}>
                        Cancel
                    </Button>
                    <Button variant="primary" className="btn btn-primary btn-add" onClick={() => { handleDeleteResponse(true) }}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default DeleteModal;